import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionBlock: {
    id: 'block.section.title',
    defaultMessage: 'Section block',
  },
  fieldsetDefaultTitle: {
    id: 'block.fieldset.default.title',
    defaultMessage: 'Default',
  },
  titlePropertyTitle: {
    id: 'block.property.title.title',
    defaultMessage: 'Title',
  },
  titlePropertyDescription: {
    id: 'block.property.title.description',
    defaultMessage: 'Section friendly name',
  },
  asPropertyTitle: {
    id: 'block.property.as.title',
    defaultMessage: 'HTML5 element',
  },
  asPropertyDescription: {
    id: 'block.property.as.description',
    defaultMessage: 'Select HTML5 element to be used for this block',
  },
  restrictedBlockTitle: {
    id: 'block.property.restricted.title',
    defaultMessage: 'Restricted block',
  },
  leftAlignmentTitle: {
    id: 'block.property.leftAlignment.title',
    defaultMessage: 'Left block alignment',
  },
  leftAlignmentDescription: {
    id: 'block.property.leftAlignment.description',
    defaultMessage: 'Select how the left block should be vertically aligned',
  },
  swapOnMobileTitle: {
    id: 'block.property.swapOnMobile.title',
    defaultMessage: 'Swap the elements',
  },
  swapOnMobileDescription: {
    id: 'block.property.swapOnMobile.description',
    defaultMessage:
      'If enabled, the vertical stack order on mobile devices is swaped.',
  },
});

const Schema = (intl) => ({
  title: intl.formatMessage(messages.sectionBlock),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.fieldsetDefaultTitle),
      fields: [
        'title',
        'as',
        'restrictedBlock',
        'leftBlock',
        'swapOnMobile',
      ],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.titlePropertyTitle),
      description: intl.formatMessage(messages.titlePropertyDescription),
      type: 'string',
    },
    as: {
      title: intl.formatMessage(messages.asPropertyTitle),
      description: intl.formatMessage(messages.asPropertyDescription),
      type: 'string',
      factory: 'Choice',
      default: 'div',
      choices: [
        ['div', 'div'],
        ['section', 'section'],
        ['article', 'article'],
        ['aside', 'aside'],
        ['details', 'details'],
      ],
    },
    restrictedBlock: {
      title: intl.formatMessage(messages.restrictedBlockTitle),
      type: 'boolean',
    },
    leftBlock: {
      title: intl.formatMessage(messages.leftAlignmentTitle),
      description: intl.formatMessage(messages.leftAlignmentDescription),
      type: 'string',
      factory: 'Choice',
      default: 'top',
      choices: [
        ['top', 'top'],
        ['middle', 'middle'],
        ['bottom', 'bottom'],
      ],
    },
    swapOnMobile: {
      title: intl.formatMessage(messages.swapOnMobileTitle),
      description: intl.formatMessage(messages.swapOnMobileDescription),
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export default Schema;
